import { useFragment } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { TokenAmountAsCurrencyDisplayFragment$key } from "./__generated__/TokenAmountAsCurrencyDisplayFragment.graphql";
import { ethers } from "ethers";
import { useMemo } from "react";

export type Props = {
  fragment: TokenAmountAsCurrencyDisplayFragment$key;
  maximumSignificantDigits?: number;
};

export function TokenAmountAsCurrencyDisplay({
  fragment,
  maximumSignificantDigits = 5,
}: Props) {
  const { amount, decimals, currency } = useFragment(
    graphql`
      fragment TokenAmountAsCurrencyDisplayFragment on TokenAmount {
        amount
        decimals
        currency
      }
    `,
    fragment
  );

  const formattedNumber = useMemo(() => {
    const number = Number(ethers.utils.formatUnits(amount, decimals));

    const numberFormat = new Intl.NumberFormat("en", {
      style: "currency",
      currency: "USD",
      currencyDisplay: "code",
      compactDisplay: "short",
      notation: "compact",
      maximumSignificantDigits,
    });

    const parts = numberFormat.formatToParts(number);
    return parts
      .filter((part) => part.type !== "currency" && part.type !== "literal")
      .map((part) => part.value)
      .join("");
  }, [amount, decimals, maximumSignificantDigits]);

  return (
    <>
      {formattedNumber} {currency}
    </>
  );
}
